import MainLayout from "@/components/layout/admin/MainLayout.vue";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import axios from "axios";

export default {
  name: "shiftPatternList",
  components: {
    MainLayout,
    AdvancedLaravelVuePaginate,
    Loading
  },

  data() {
    return {
      noDataMsg: CONFIG.NO_DATA_FOUND,
      patternList: {},
      isLoading: false,
      pattern_name: "",
      search_status: false,
      currentPage: 1
    };
  },

  methods: {
    fetchPatternLists(page = 1) {
      this.currentPage = page;
      this.isLoading = true;
      axios.get('/shift-pattern?page=' + page)
      .then((response) => {
        this.patternList = response.data;
      })
      .catch((err) => {
        if (err.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
        console.log(err)
      })
      .finally(() => {
        this.isLoading = false;
      })
    },

    searchPatternName(page = 1) {
      this.currentPage = page;
      this.isLoading = true;
      axios.get('/shift-pattern/search?page=' + page, {
          params: {
            pattern_name: this.pattern_name
          }
        })
        .then((response) => {
          this.patternList = response.data;
          this.isLoading = false;
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log(err)
        })
    },

    reset() {
      this.pattern_name = '';
      this.isLoading = true;
      this.fetchPatternLists();
      this.isSearched = false;
    },

    showEdit(patternId) {
      this.$router.push({
        name: "shiftPatternEdit",
        params: {
          id: patternId
        }
      });
    },

    showDetail(patternId) {
      this.$router.push({
        name: "shiftPatternDetail",
        params: {
          id: patternId
        }
      });
    },

    confirmDelete(patternId) {
      if (window.confirm("Are you sure you want to delete?")) {
        this.deletePattern(patternId);
      }
    },

    deletePattern(patternId) {
      this.isLoading = true;
      axios.delete('/shift-pattern/' + patternId)
      .then((res) => {
        if (res.data.success == true) {
          if (this.patternList.data.length === 1 && this.currentPage > 1) {
            this.currentPage--;
          }
          this.fetchPatternLists(this.currentPage);
          this.$notification.success('Shift Pattern deleted successfully', {
            timer: 3,
            position: "bottomCenter"
          });
        } else {
          this.$notification.error("Shift Pattern Not Found", {
            timer: 3,
            position: "bottomCenter"
          });
          this.fetchPatternLists();
        }
      })
      .catch((err) => {
        if (err.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        } else if (err.response.status == 404) {
          this.$notification.error("Shift Pattern Not Found", {
            timer: 3,
            position: "bottomCenter"
          });
        }
        this.isLoading = false;
        console.log("Shift Pattern Delete Error->", err.response.data);
      })
    },

    showCreate() {
      this.$router.push({
        name : "shiftPatternCreate"
      });
    }
  },

  mounted() {
    this.isLoading = true;
    this.fetchPatternLists();
  },
};
